"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineActions = void 0;
function defineActions(state, getters, mutations, actions) {
    var _a;
    return (_a = actions !== null && actions !== void 0 ? actions : mutations) !== null && _a !== void 0 ? _a : getters;
}
exports.defineActions = defineActions;
